// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"063d003d2efb7ba5","1620":"052bdda62b780bad","6735":"a3eb23c166e5ee5a","7994":"daf66b841e78d103"}[chunkId] + ".js";
};